// Предупреждение новичку: атака на замок другого игрока снимет щит новичка. Сервер не пропустит такую атаку без
// согласия и отвечает ошибкой newbie_shield_confirm, поэтому окно появляется на любом экране отправки войск и только
// тогда, когда щит действительно есть. Игрокам без щита и атакам на лагеря оно не показывается.
import { duration } from '@/lib/format';
import { Button, Modal } from '@/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Ask {
  until: string | null;
  answer: (accepted: boolean) => void;
}

let show: ((ask: Ask) => void) | null = null;

function askShieldLoss(until: string | null): Promise<boolean> {
  return new Promise((answer) => {
    if (show) show({ until, answer });
    else answer(false);
  });
}

/** Отправить атаку; null — новичок передумал, войска никуда не ушли. */
export async function withShieldConsent<T>(send: (accept: boolean) => Promise<T>): Promise<T | null> {
  try {
    return await send(false);
  } catch (e) {
    const error = e as { code?: string; details?: { until?: string } } | null;
    if (error?.code !== 'newbie_shield_confirm') throw e;
    const until = error.details?.until ?? null;
    return (await askShieldLoss(until)) ? send(true) : null;
  }
}

export function NewbieShieldPrompt() {
  const { t } = useTranslation();
  const [ask, setAsk] = useState<Ask | null>(null);
  useEffect(() => {
    show = setAsk;
    return () => {
      show = null;
    };
  }, []);
  const close = (accepted: boolean) => {
    ask?.answer(accepted);
    setAsk(null);
  };
  const left = ask?.until ? Math.max(0, (new Date(ask.until).getTime() - Date.now()) / 1000) : 0;
  return (
    <Modal open={!!ask} onClose={() => close(false)} title={`🛡 ${t('game:newbieShield.title')}`}>
      <div className="space-y-3">
        <p>{t('game:newbieShield.text')}</p>
        {left > 0 && (
          <p className="text-sm text-gold-300">{t('game:newbieShield.left', { time: duration(left) })}</p>
        )}
        <p className="text-sm text-parchment-300">{t('game:newbieShield.reason')}</p>
        <Button variant="danger" className="w-full" onClick={() => close(true)}>
          ⚔️ {t('game:newbieShield.attack')}
        </Button>
        <Button variant="secondary" className="w-full" onClick={() => close(false)}>
          {t('game:newbieShield.keep')}
        </Button>
      </div>
    </Modal>
  );
}
